import FilePreviewModal from './FilePreviewModal.component';

export default FilePreviewModal;